<script lang="ts">
import BrandLogo from './BrandLogo.svelte';
import HeroBanner from './HeroBanner.svelte'
import PartnerWithDescription from './PartnerWithDescription.svelte';
import PartnerAlpha from "./PartnerAlpha.svelte";
import { widgetState } from "../store/widget.store";

const widgetType = {
    "Layout 1": PartnerWithDescription,
    "Layout 2": PartnerAlpha,
}
</script>

<div class="widget-container"  style="background-color: #{$widgetState.config.background_color}">
    {#if Boolean($widgetState.config.ad_text)}
        <p class="tiny-text text-xs">{$widgetState.config.ad_text}</p>    
    {/if}

    <HeroBanner
        textAlign='text-center'
        showSubtitle={true}
        titleColor="{$widgetState.config.title_color}"
    />

    <div class="partners">
        {#each $widgetState.config.partners as partner, index}    
            <svelte:component this={widgetType[$widgetState.config.widget_type]}
                partner={partner}
                ctaText="{$widgetState.config.cta_text}"
                ctaColor="{$widgetState.config.cta_color}"
                ctaTextColor="{$widgetState.config.cta_text_color}"
                partnerRowBackgroundColor={$widgetState.config.partner_row_background_color}
                displayStarRating={$widgetState.config.display_star_rating}
            />
        {/each}
    </div>
    
    <BrandLogo
        logoColor={$widgetState.config.logo_color}
        positioning='justify-center'
    />
</div>


<style lang=scss>
    .widget-container {
        display: grid;
        grid-template-areas: 
            "ad-text"
            "hero-banner"
            "partners"
            "brand-logo";

        .tiny-text {
            grid-area: ad-text;
            text-align: right;
            color: #999;
        }

        .partners {
            grid-area: partners;
            padding-top: 20px;
        }

    }
</style>